import { PageHero } from "@/components/layout/PageHero";
import { LoadingPage } from "@/components/ui/LoadingPage";
import { StatCard } from "@/components/ui/StatCard";
import { PageContainer } from "@/design-system";
import { Brain } from "lucide-react";

import { useAuth } from "@/features/auth/hooks/useAuth";
import { TopRiskMembers } from "@/features/intelligence/components/TopRiskMembers";
import { useIntelligenceDashboard } from "@/features/intelligence/hooks/useIntelligenceDashboard";

export function IntelligencePage() {
  const { churchId } = useAuth();

  const {
    data,
    isLoading,
    isError,
  } = useIntelligenceDashboard(churchId);

  if (isLoading) {
    return <LoadingPage />;
  }

  if (isError || !data) {
    return (
      <PageContainer>
        <PageHero
          icon={<Brain size={30} />}
          title="Ministry Intelligence"
          subtitle="Unable to load intelligence dashboard."
        />
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <PageHero
        icon={<Brain size={30} />}
        title="Ministry Intelligence"
        subtitle="See More. Care Better. Lead Smarter."
      />

      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
        <StatCard
          title="Church Health"
          value={data.church_health}
        />

        <StatCard
          title="Assessments"
          value={data.total_assessments}
        />

        <StatCard
          title="Critical Members"
          value={data.critical_members}
        />

        <StatCard
          title="At Risk Members"
          value={data.at_risk_members}
        />
      </div>

      <div className="mt-6">
        <TopRiskMembers members={data.members} />
      </div>
    </PageContainer>
  );
}